<template>
  <div :class="`barfiller ${color}`">
    <div class="tipWrap" style="display: inline">
      <span
        v-if="rtl"
        :class="`tip rounded ${color}`"
        :style="`right:calc(${title}% - 20px);`"
        >{{ title }}%</span
      >
      <span
        v-else
        :class="`tip rounded ${color}`"
        :style="`left:calc(${title}% - 20px);`"
        >{{ title }}%</span
      >
    </div>
    <span :class="`fill ${color}`" :style="`width:${title}%`"></span>
  </div>
</template>
<script>
import themeConfig from '@/../themeConfig.js'
export default {
  name: "pick-progress-bar",
  props: {
    title: {
      default: null,
      type: [String, Number],
    },
    color: {
      default: null,
      type: [String, Number],
    }
  },
  data: function () {
    return {
      rtl: themeConfig.rtl
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/components/progressbar.scss";
</style>
